import { MasterServiceInterface } from './types/masterDataTypes';
import { findMasterData } from './utils';

/**
 * * masterDataService
 * @description Service to set master data get its values
 *
 * * @function setMasterDatas
 *   @param Map<string, Feature>
 *   @description to set master data array
 * * @function getMasterData
 *   @returns specific master data object
 *   @param key:string
 *   @description to get the master data object based on key
 */
const MasterDataService: MasterServiceInterface = (function (root, factory) {
  let MasterDataService: MasterServiceInterface = {} as MasterServiceInterface;
  if (root) {
    // If instance exists use it otherwise create new.
    if (root.MasterDataService) {
      ({ MasterDataService } = root);
    } else {
      root.MasterDataService = MasterDataService;
      return factory(MasterDataService);
    }
  }

  return MasterDataService;
})(
  (typeof window === 'object' && window) || (typeof globalThis === 'object' && globalThis) || this,
  function (MasterDataService: MasterServiceInterface) {
    let masterDataMap: Map<string, {}> = new Map();

    // Adding methods to Instance.
    MasterDataService.setMasterDatas = (masterData: Map<string, {}>) => {
      masterDataMap = masterData;
    };
    MasterDataService.getMasterData = function <T = undefined>(key: string): T | undefined {
      return findMasterData<T>(masterDataMap, key);
    };

    return MasterDataService;
  },
);

export { MasterDataService };
export type { MasterServiceInterface };
